import {
  FETCH_COMMON_DETAILS,
  FETCH_COMMON_DETAILS_SUCCESS,
  FETCH_COMMON_DETAILS_FAILURE,
  SHOP_BY_DEPARTMENT_SELECTED_OPTION_NAME,
} from "redux/constants/actionTypes";

let initialState = {
  commonDetailsData: {},
  commonDetailsDataLoading: true,
  commonDetailsDataError: "",
  shopByDepartmentSelectedOptionName: "",
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMMON_DETAILS:
      return {
        ...state,
        commonDetailsDataLoading: true,
      };
    case FETCH_COMMON_DETAILS_SUCCESS:
      const shopByDepartmentSelectedOptionName =
        action.payload?.ecom_section?.sub_department?.find(
          i => i.is_mealkit === "1"
        )?.name ?? ""
      const top_dropdown_section = action.payload?.top_dropdown_section?.map(i => {
        let name = i.name?.toLowerCase();
        if (name === "products") {
          i.name = "All Products"
        } else if (name === "coupons") {
          i.name = "All Coupons"
        }
        return i;
      })

      return {
        ...state,
        commonDetailsDataLoading: false,
        commonDetailsData: {
          ...action.payload,
          top_dropdown_section
        },
        shopByDepartmentSelectedOptionName,
      };
    case FETCH_COMMON_DETAILS_FAILURE:
      return {
        ...state,
        commonDetailsDataLoading: false,
        commonDetailsDataError: action.payload.error,
      };
      case SHOP_BY_DEPARTMENT_SELECTED_OPTION_NAME:
        return {
          ...state,
          shopByDepartmentSelectedOptionName: action.payload,
        };
    default:
      return state;
  }
};

export default commonReducer;
